import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { WatercraftContext } from 'wmic-pe-capability-gateway-quoteandbind-ho-react';
import WMICHOEquipmentDetails from '../WMICHOEquipmentDetails/WMICHOEquipmentDetails';
import metadata from './WMICHOTrailerInfoDetails.metadata.json5';
import messages from './WMICHOTrailerInfoDetails.messages';

function WMICHOTrailerInfoDetails({
    id,
    trailerData,
    onValidate,
    showErrors,
    readOnly,
    baseData
}) {
    const {
        onValidate: setComponentValidation,
        isComponentValid,
    } = useValidation(id);
    const { updateWatercraftRiskView } = useContext(WatercraftContext);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        // if component is unmounted, report as valid so it doesn't break the rest of the form
        return () => {
            if (onValidate) {
                onValidate(true, id);
            }
        }
    }, [id, onValidate, isComponentValid]);

    const overrideProps = {
        '@field': {
            readOnly,
            parentNode: trailerData,
        },
        wmichoEquipmentDetailsTrailer: {
            watercraftComponentVM: trailerData,
            onValidate: setComponentValidation,
            readOnly,
            showErrors,
            baseData
        },
    };

    const resolvers = {
        resolveComponentMap: {
            WMICHOEquipmentDetails,
        },
    };

    return (
        <ViewModelForm
            model={trailerData}
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            onModelChange={updateWatercraftRiskView}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

WMICHOTrailerInfoDetails.propTypes = {
    trailerData: PropTypes.shape({}).isRequired,
    readOnly: PropTypes.bool,
};

WMICHOTrailerInfoDetails.defaultProps = {
    readOnly: false,
};

export default WMICHOTrailerInfoDetails;
